var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSolution3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "686px",
    height: "608px",
    viewBox: "0 0 686 608",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 7") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "-57.5%",
    y: "-59.1%",
    width: "214.9%",
    height: "218.1%",
    filterUnits: "objectBoundingBox",
    id: "filter-1"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 50,
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    x: "-47.5%",
    y: "-48.7%",
    width: "194.9%",
    height: "197.4%",
    filterUnits: "objectBoundingBox",
    id: "filter-2"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 50,
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "StaFihub",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "V2-Copy",
    transform: "translate(-654.000000, -3405.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7",
    transform: "translate(804.000000, 3555.000000)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-23-Copy-4",
    fill: "#FFD5E2",
    opacity: 0.3,
    filter: "url(#filter-1)",
    cx: 255.5,
    cy: 181,
    rx: 130.5,
    ry: 127
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-23-Copy-5",
    fill: "#6758FF",
    opacity: 0.3,
    filter: "url(#filter-2)",
    cx: 158,
    cy: 154,
    rx: 158,
    ry: 154
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(218.000000, 173.000000) rotate(-270.000000) translate(-218.000000, -173.000000) translate(112.000000, 41.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4-Copy-5",
    transform: "translate(18.000000, 135.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-Copy-21",
    fill: "#6758FF",
    points: "36.5570283 42.8095238 130.599581 42.8095238 130.599581 129 36.5570283 129"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-Copy-17",
    fill: "#6758FF",
    points: "0.191489362 0 133.796303 0 133.796303 43.4678016 0.191489362 43.4678016"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-Copy-22",
    fill: "#8A7FFF",
    points: "120.510638 42.8095238 175.240321 42.8095238 175.240321 86.2773254 120.510638 86.2773254"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-19-Copy-7",
    fill: "#B16BD4",
    points: "0.191489362 0 42.0435996 0 42.0435996 20.9289415 0.191489362 20.9289415"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-19-Copy-8",
    fill: "#B16BD4",
    points: "77.6382979 64.9047619 146.968608 64.9047619 146.968608 108.372564 77.6382979 108.372564"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-20-Copy-19",
    fill: "#FF7FA7",
    points: "126.042553 12.4285714 146.968608 12.4285714 146.968608 15.6484086 126.042553 15.6484086"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-20-Copy-26",
    fill: "#FF7FA7",
    points: "170 51 181.245204 51 181.245204 54.2198372 170 54.2198372"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-20-Copy-21",
    fill: "#FF7FA7",
    points: "47.212766 24.8571429 101.942449 24.8571429 101.942449 28.07698 47.212766 28.07698"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-20-Copy-25",
    fill: "#FF7FA7",
    points: "8 72 102.042553 72 102.042553 75.2198372 8 75.2198372"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-20-Copy-22",
    fill: "#FF7FA7",
    points: "22.3191489 9.66666667 77.0488315 9.66666667 77.0488315 12.8865038 22.3191489 12.8865038"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-4-Copy-6",
    transform: "translate(106.000000, 58.500000) rotate(-180.000000) translate(-106.000000, -58.500000) "
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-Copy-21",
    fill: "#6758FF",
    points: "36.5570283 42.8095238 130.599581 42.8095238 130.599581 117 36.5570283 117"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-Copy-17",
    fill: "#6758FF",
    points: "0.191489362 0 133.796303 0 133.796303 43.4678016 0.191489362 43.4678016"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-Copy-22",
    fill: "#8A7FFF",
    points: "120.510638 42.8095238 206.346006 42.8095238 206.346006 86.2773254 120.510638 86.2773254"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-19-Copy-7",
    fill: "#B16BD4",
    points: "0.191489362 0 42.0435996 0 42.0435996 20.9289415 0.191489362 20.9289415"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-19-Copy-8",
    fill: "#B16BD4",
    points: "77.6382979 64.9047619 146.968608 64.9047619 146.968608 85.8337034 77.6382979 85.8337034"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-20-Copy-19",
    fill: "#FF7FA7",
    points: "126.042553 12.4285714 146.968608 12.4285714 146.968608 15.6484086 126.042553 15.6484086"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-20-Copy-26",
    fill: "#FF7FA7",
    points: "200.723404 69.047619 211.968608 69.047619 211.968608 72.2674562 200.723404 72.2674562"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-20-Copy-21",
    fill: "#FF7FA7",
    points: "47.212766 24.8571429 101.942449 24.8571429 101.942449 28.07698 47.212766 28.07698"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-20-Copy-25",
    fill: "#FF7FA7",
    points: "19.190443 60.7619048 61.0425532 60.7619048 61.0425532 63.9817419 19.190443 63.9817419"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-20-Copy-22",
    fill: "#FF7FA7",
    points: "22.3191489 9.66666667 77.0488315 9.66666667 77.0488315 12.8865038 22.3191489 12.8865038"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolution3);
export default __webpack_public_path__ + "static/media/solution3.63d0c117876942399653f6313ce86dcd.svg";
export { ForwardRef as ReactComponent };